// このアプリのテーマ（assets/theme/components/button/outlined）では、枠線ボタンの既定の文字色が
// ごく薄いグレー（light）になっていて、白い背景では読めない。未来ボードの枠線ボタンは、色を明示する。
export const outlinedButtonSx = {
  color: "text.primary",
  borderColor: "grey.500",
  "&.Mui-disabled": { color: "text.disabled", borderColor: "grey.300" },
} as const;
